<template>
  <div ref="letter" class="letter">
    <template v-if="isReadyToRender">
      <DefaultNoticeOfViolation
        v-if="template === 'default'"
        :model="letterContext"
        :voluntary="options.voluntary"
        v-on="$attrs"
      />
      <OOBNoticeOfCompliance
        v-else-if="template === 'oob'"
        :model="letterContext"
        :type="options.type"
        :destination="options.destination"
        v-on="$attrs"
      />
      <SoPoLetter
        v-else-if="template === 'sopo'"
        :model="letterContext"
        :first="options.first"
        v-on="$attrs"
      />
      <FalmouthLetter
        v-else-if="template === 'falmouth'"
        :model="letterContext"
        :first="options.first"
        v-on="$attrs"
      />
      <FreeportLetter
        v-else-if="template === 'freeport'"
        :model="letterContext"
        :first="options.first"
        v-on="$attrs"
      />
      <PortlandLetter
        v-else-if="template === 'portland'"
        :model="letterContext"
        :first="options.first"
        :registered="options.registered"
        v-on="$attrs"
      />
      <CapeElizabethLetter
        v-else-if="template === 'cape_elizabeth'"
        :model="letterContext"
        v-on="$attrs"
      />
      <CascoLetter
        v-else-if="template === 'casco'"
        :model="letterContext"
        @ready="$emit('ready')"
      />
      <CascoViolationLetter
        v-else-if="template === 'casco_violation'"
        :model="letterContext"
        @ready="$emit('ready')"
      />
      <div v-else class="p-3 text-center text-danger">
        Could not load the '{{ template }}' letter template.
      </div>
    </template>
    <div v-else class="p-3 text-center text-muted">
      This letter is missing context and cannot be previewed.
    </div>
    <EvidenceAttachment
      v-if="includeScreenshot && letterContext?.hasEvidenceScreenshot"
      :city-id="letterContext.cityId"
      :listing-id="letterContext.listingId"
      :evidence="letterContext.evidence"
      :source-url="letterContext.evidence?.sourceUrl"
      :captured-at="letterContext.evidence?.capturedAt"
    />
  </div>
</template>

<script>
import DefaultNoticeOfViolation from "@/components/letters/DefaultLetter.vue";
import OOBNoticeOfCompliance from "@/components/letters/OOBLetter.vue";
import SoPoLetter from "@/components/letters/SoPoLetter.vue";
import FalmouthLetter from "@/components/letters/FalmouthLetter.vue";
import Correspondence from "@/models/Correspondence";
import PortlandLetter from "@/components/letters/PortlandLetter.vue";
import EvidenceAttachment from "@/components/letters/EvidenceAttachment.vue";
import {buildLetterContextForCorrespondence, LetterContext} from "@/models/letterContext";
import CapeElizabethLetter from "@/components/letters/CapeElizabethLetter.vue";
import FreeportLetter from "@/components/letters/FreeportLetter.vue";
import CascoLetter from "@/components/letters/CascoLetter.vue";
import CascoViolationLetter from "@/components/letters/CascoViolationLetter.vue";

export default {
  components: {
    CascoViolationLetter,
    CascoLetter,
    FreeportLetter,
    CapeElizabethLetter,
    EvidenceAttachment, PortlandLetter, SoPoLetter, OOBNoticeOfCompliance, FalmouthLetter, DefaultNoticeOfViolation},
  props: {
    letter: Correspondence,
    context: LetterContext,
    includeScreenshot: Boolean
  },
  emits: [
    'ready'
  ],
  computed: {
    resolvedLetter() {
      return this.letter || null;
    },
    letterContext() {
      return this.context || buildLetterContextForCorrespondence(this.resolvedLetter);
    },
    isReadyToRender() {
      return Boolean(
        this.resolvedLetter &&
        this.letterContext &&
        this.letterContext.city &&
        this.letterContext.property
      );
    },
    template() {
      return this.resolvedLetter?.template || null;
    },
    options() {
      return this.resolvedLetter?.options || {};
    }
  }
}

</script>

<style>
img.seal-logo {
  max-height: 120px;
  max-width: 120px;
  object-fit: contain;
}
img.seal-logo.lg {
  max-width: 240px;
}
@media print {
  @page {
    size:auto;
    margin:0.5in 0.5in;
  }
  .letter {
    page-break: break-before;
  }
}
.letter {
  font-size: 12px;
  line-height: 14px;
  page-break: break-before;
}

</style>
